
import flatten from 'flatten'

const reduceByKeys = (keys, obj) => {
  return keys.reduce((memo, key) => {
    return memo.concat(obj[key])
  }, [])
}

function join (keys, run) {
  const topLevel = reduceByKeys(keys, run.events)

  // build a flattened array of collection-level issues
  const collectionIssues = flatten(run.collections.map((collection) => {
    const issues = reduceByKeys(keys, collection.events)

    // set objectType as collection that issue pertains to
    issues.forEach((issue) => {
      issue.collection = collection.name
    })

    return issues
  }))

  return topLevel.concat(collectionIssues)
}

export const joinErrors = run => join(['error', 'critical'], run)
export const joinWarnings = run => join(['warning'], run)



// WEBPACK FOOTER //
// ./lib/runs/join.js